module.exports = __webpack_public_path__ + "static/group-8@3x-427a73879f41e9ada484ddf0516fde88.png";